import { Abstract } from '@tsdi/ioc';
import { MvcMiddlewares } from '../middlewares/MvcMiddlewares';
import { MvcContext } from '../MvcContext';

@Abstract()
export abstract class BeforeMidddlewareStartupService {

    /**
     * to startup service before middlewares setup.
     *
     * @abstract
     * @param {MvcContext} ctx
     * @param {MvcMiddlewares} [middlewares]
     * @returns {Promise<void>}
     * @memberof BeforeMidddlewareSetup
     */
    abstract startup(ctx: MvcContext, middlewares?: MvcMiddlewares): Promise<void>;

                    static ρAnn(): any {
                        return {"name":"BeforeMidddlewareStartupService","params":{"startup":["ctx","middlewares"]}};
                    }
               }
